import React from 'react'
import Input from '../../root/components/common/input'
import { makeStyles } from '@material-ui/core'
import { IconButton } from '../../root/components/common'
import { mdiClose } from '@mdi/js'

export default function SimCardsTableSearch({ filters, onSearch, locale }) {
    const classes = useStyles()

    return (
        <Input
            value={filters.search}
            label={locale.common.search}
            type="text"
            setValue={onSearch}
            debounce={600}
            endIcon={() =>
                filters.search ? (
                    <div className={classes.searchClearIcon}>
                        <IconButton
                            size={0.8}
                            onClick={() => onSearch('')}
                            icon={mdiClose}
                        />
                    </div>
                ) : null
            }
        />
    )
}

const useStyles = makeStyles(() => ({
    searchClearIcon: {
        right: 15,
        position: 'absolute'
    }
}))
